import { useComposedRefs } from "@radix-ui/react-compose-refs";
import {
  forwardRef,
  type AudioHTMLAttributes,
  type VideoHTMLAttributes,
} from "react";

import { useMediaElementMuteActivity } from "@/lib/hooks/conversations/use-notification-mute-activity";

export const MutingAudio = forwardRef<
  HTMLAudioElement,
  AudioHTMLAttributes<HTMLAudioElement>
>(function MutingAudio(props, forwardedRef) {
  const muteRef = useMediaElementMuteActivity("media-audio");
  const ref = useComposedRefs(muteRef, forwardedRef);
  return <audio ref={ref} {...props} />;
});

export const MutingVideo = forwardRef<
  HTMLVideoElement,
  VideoHTMLAttributes<HTMLVideoElement>
>(function MutingVideo(props, forwardedRef) {
  const muteRef = useMediaElementMuteActivity("media-video");
  const ref = useComposedRefs(muteRef, forwardedRef);
  return <video ref={ref} {...props} />;
});
